module.exports = __webpack_public_path__ + "img/placeholder.36a49820.jpg";